import { render, staticRenderFns } from "./IntegrationFailedAttemptsModal.vue?vue&type=template&id=31faff8f&scoped=true"
import script from "./IntegrationFailedAttemptsModal.vue?vue&type=script&lang=js"
export * from "./IntegrationFailedAttemptsModal.vue?vue&type=script&lang=js"
import style0 from "./IntegrationFailedAttemptsModal.vue?vue&type=style&index=0&id=31faff8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31faff8f",
  null
  
)

export default component.exports